var map = {
	"./ar.png": 216,
	"./bn.png": 6869,
	"./cr.png": 978,
	"./de.png": 8876,
	"./el.png": 8154,
	"./en.png": 1256,
	"./es.png": 8845,
	"./fa.png": 4846,
	"./fr.png": 2757,
	"./hi.png": 3916,
	"./id.png": 2790,
	"./it.png": 3526,
	"./ja.png": 5498,
	"./ko.png": 3455,
	"./la.png": 5648,
	"./ms.png": 4421,
	"./pt.png": 6561,
	"./rm.png": 9470,
	"./ru.png": 5814,
	"./sv.png": 3366,
	"./th.png": 9673,
	"./tr.png": 2019,
	"./ur.png": 8804,
	"./vi.png": 2326,
	"./zh-TW.png": 6109,
	"./zh-cn.png": 1345
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6726;